module.exports = __webpack_public_path__ + "static/media/OverallInclusion.4d1ce266.svg";